goog.provide("shadow.js.shim.module$date_fns$parseISO$default");
shadow.js.shim.module$date_fns$parseISO$default = esm_import$date_fns$parseISO.default;
